var _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect, _path8, _circle, _circle2, _circle3, _circle4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgImgEmptyRichMenu = function SvgImgEmptyRichMenu(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66 15H14C11.2386 15 9 17.2386 9 20V58C9 60.7614 11.2386 63 14 63H66C68.7614 63 71 60.7614 71 58V20C71 17.2386 68.7614 15 66 15Z",
    fill: "white",
    stroke: "#BDBDBD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 28H14.5C13.6716 28 13 28.6716 13 29.5C13 30.3284 13.6716 31 14.5 31H28.5C29.3284 31 30 30.3284 30 29.5C30 28.6716 29.3284 28 28.5 28Z",
    fill: "#BDBDBD",
    fillOpacity: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 42H14.5C13.6716 42 13 42.6716 13 43.5C13 44.3284 13.6716 45 14.5 45H18.5C19.3284 45 20 44.3284 20 43.5C20 42.6716 19.3284 42 18.5 42Z",
    fill: "#BDBDBD",
    fillOpacity: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5 42H23.5C22.6716 42 22 42.6716 22 43.5C22 44.3284 22.6716 45 23.5 45H35.5C36.3284 45 37 44.3284 37 43.5C37 42.6716 36.3284 42 35.5 42Z",
    fill: "#BDBDBD",
    fillOpacity: 0.3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5 35H14.5C13.6716 35 13 35.6716 13 36.5C13 37.3284 13.6716 38 14.5 38H55.5C56.3284 38 57 37.3284 57 36.5C57 35.6716 56.3284 35 55.5 35Z",
    fill: "#BDBDBD",
    fillOpacity: 0.3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5 49H14.5C13.6716 49 13 49.6716 13 50.5C13 51.3284 13.6716 52 14.5 52H46.5C47.3284 52 48 51.3284 48 50.5C48 49.6716 47.3284 49 46.5 49Z",
    fill: "#BDBDBD",
    fillOpacity: 0.3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 22.5H70.5",
    stroke: "#BDBDBD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 28.5,
    y: 43.5,
    width: 34,
    height: 29,
    rx: 3.5,
    fill: "#EBEBEB",
    stroke: "#BDBDBD"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7144 64.8572L39.9059 58.9735C40.6021 58.1844 41.7908 58.0699 42.6249 58.7115L45.1376 60.6443C46.0098 61.3152 47.2601 61.1555 47.9357 60.2869L55.7144 50.2858",
    stroke: "#BDBDBD",
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 46.7143,
    cy: 61.0001,
    r: 1.21429,
    fill: "white",
    stroke: "#BDBDBD"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 55.2858,
    cy: 50.7143,
    r: 1.21429,
    fill: "white",
    stroke: "#BDBDBD"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 41.5715,
    cy: 58.4285,
    r: 1.21429,
    fill: "white",
    stroke: "#BDBDBD"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.7143,
    cy: 64.4285,
    r: 1.21429,
    fill: "white",
    stroke: "#BDBDBD"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgImgEmptyRichMenu);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/img_emptyRichMenu.39c4043197aa4c9dd0f1cc7f17818411.svg";